import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Gto } from '../../base/vo/gto';
import { AcoesService } from '../acoes.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { Subscription }   from 'rxjs';

@Component({
    selector: 'app-acao-prorrogar',
    inputs: ['gto'],
    templateUrl: './acao-prorrogar.component.html',
    styleUrls: ['./acao-prorrogar.component.css']
})
export class AcaoProrrogarComponent implements OnInit {

    @Input() gto: Gto;
    @Output() onAction = new EventEmitter();
    display: boolean = false;
    public loading:boolean = false;

    constructor(private acoesService :AcoesService,
        private messageService: MessageService) {
    }

    ngOnInit() {
    }

    abrirDialog(){
        this.display = true;
    }

    prorrogar(): void {
    	if(!this.loading) {
	        this.loading = true;
	        this.acoesService.prorrogaGTO(this.gto.numero)
	            .subscribe(data => { 
	                this.onSuccess();
	            }, err => {
	            	this.onAction.emit(false);
	            	this.loading = false;
	            });
        }
    }


    onSuccess() {
    	this.messageService.add({severity:'success', summary:'Prorrogação GTO', detail: 'A GTO foi prorrogada com sucesso!'});
    	
    	this.loading = false;
        this.fecharDialog();
        
        this.onAction.emit(true);
    }

    fecharDialog(){
        this.display = false;   
    }

}



// WEBPACK FOOTER //
// ./src/app/components/acoes/acao-prorrogar/acao-prorrogar.component.ts